import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "border-cap-butt-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", transform: "translate(7 3.5)" },
        React.createElement("path", { fill: "currentColor", d: "M7 0v10H1V6.5h1.5a.5.5 0 0 0 .492-.41L3 6V4a.5.5 0 0 0-.5-.5H1V0h6Z", opacity: 0.2 }),
        React.createElement("rect", { width: 2, height: 2, x: 0.5, y: 4, stroke: "currentColor", rx: 0.5 }),
        React.createElement("path", { stroke: "currentColor", d: "M2.5 5H7" }),
        React.createElement("path", { stroke: "currentColor", strokeLinejoin: "round", d: "M7 0H1.5v4m0 2v4H7" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
